<template>
  <span>
    <span v-if="parseUrl(url).protocol === 'https:'" class="mr-1">
      <v-icon small color="success">mdi-lock</v-icon>
    </span>
    <span v-else class="mr-1"><v-icon small>mdi-lock</v-icon></span>

    <span
      v-show="!(mobile === 'hide-path' && $vuetify.breakpoint.smAndDown)"
      class="black--text"
      >{{ parseUrl(url).host }}</span>
    <span v-show="!(mobile === 'hide-domain' && $vuetify.breakpoint.smAndDown)">
      <span class="grey--text">{{ parseUrl(url).pathname }}</span>
      <span class="grey--text">{{ parseUrl(url).search }}</span>
      <span class="grey--text">{{ parseUrl(url).hash }}</span>
    </span>
  </span>
</template>

<script>
export default {
  name: 'APrettyUrl',
  props: ['url', 'mobile'],
  methods: {
    parseUrl (url) {
      try {
        return new URL(url)
      } catch (e) {
        return {
          protocol: '',
          host: '',
          pathname: '',
          search: '',
          hash: '',
        }
      }
    }
  }
}
</script>

<style scoped>

</style>